/** Angular imports */
import { Component, computed, effect, inject } from '@angular/core';

/** Core imports */
import { AddContentStepsService } from '@core';

/**Component imports */
import { ThumbnailItemComponent } from '@ntv360/component-pantry';

@Component({
    selector: 'app-preview',
    imports: [ThumbnailItemComponent],
    templateUrl: './preview.component.html',
    styleUrl: './preview.component.scss',
})
export class PreviewComponent {
    /** Service for managing step state and draft data */
    private addContentStepsService = inject(AddContentStepsService);

    /**
     * Selected items derived from the draft.
     *
     * @remarks
     * Falls back to an empty array when no items are present.
     */
    protected selectedItems = computed(() => {
        return this.addContentStepsService.getDraft()?.selectedContents?.selectedItems ?? [];
    });

    constructor() {
        // Keeps step 1 validity in sync based on selected items
        effect(() => {
            this.addContentStepsService.setStepValidity(1, this.selectedItems().length > 0);
        });
    }

    /**
     * Removes an item from the draft's selected contents.
     *
     * @param id - Identifier of the item to remove.
     */
    protected onRemoveItem(id: string): void {
        const currentDraft = this.addContentStepsService.getDraft();
        const currentItems = currentDraft?.selectedContents?.selectedItems ?? [];
        const updatedItems = currentItems.filter((item) => item.id !== id);

        this.addContentStepsService.updateDraft('selectedContents', {
            selectedItems: updatedItems,
        });
    }
}
